<!-- 載入中 -->
<template>
    <div
        class="loading-mask bg-red"
        v-show="show"
        :style="{ height: height + 'px' }"
    >
        <div class="circle-loading-container">
            <div class="circle-loading"></div>
            <p>LOADING...</p>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
        height: {
            type: Number,
            default: 300,
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="sass" scoped>
@import '@/sass/_variable'

.loading-mask
    width: 100%
    height: 300px
    position: relative
@keyframes circleRun
    0%
        transform: rotate(0)
    50%
        transform: rotate(180deg)
    100%
        transform: rotate(360deg)

.circle-loading-container
    position: absolute
    text-align: center
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    z-index: 2
    .circle-loading
        $s: 3em
        // background-color: rgba($green, .4)
        border: 5px solid $deepGreen
        border-right-color: transparent
        border-bottom-color: transparent
        border-radius: 50%
        display: inline-block
        width: $s
        height: $s
        margin-bottom: .8em
        animation-name: circleRun
        animation-duration: 600ms
        animation-iteration-count: infinite
        animation-timing-function: ease-in
        animation-delay: -100ms
    p
        color: $deepGreen
        font-size: .8em
        line-height: 1.2
        margin-top: -.8em
</style>
